import { render, staticRenderFns } from "./DepotList.vue?vue&type=template&id=4d3bfc96&scoped=true"
import script from "./DepotList.vue?vue&type=script&lang=js"
export * from "./DepotList.vue?vue&type=script&lang=js"
import style0 from "./DepotList.vue?vue&type=style&index=0&id=4d3bfc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3bfc96",
  null
  
)

export default component.exports